export const DEFAULT_CLIENT_TIMEZONE = 'America/Toronto';

/** IANA timezone identifiers supported by the runtime, as Mantine Select data. */
export const TIMEZONE_OPTIONS: { value: string; label: string }[] = (
  typeof Intl.supportedValuesOf === 'function'
    ? Intl.supportedValuesOf('timeZone')
    : [DEFAULT_CLIENT_TIMEZONE]
).map((timezone) => ({ value: timezone, label: timezone.replaceAll('_', ' ') }));
